import reduce from 'lodash/reduce';
import * as types from './types';
import encodeCustomizable from '~/helpers/configurator-helper';
export default {
  [types.SET_OPTIONS](state, payload) {
    var currentState = state;
    currentState.options = payload;
  },
  [types.SET_DEFAULT_CUSTOMIZABLE](state, payload) {
    var currentState = state;
    var model = payload.model.substring(0, 5);
    var customizable = reduce(payload.options, (acc, option) => {
      var item = option.items.find(o => o.selected);
      if (item.subItems) {
        var subItem = item.subItems.find(e => e.selected);
        // eslint-disable-next-line no-param-reassign
        acc[subItem.type] = subItem;
      }
      if (item) {
        // eslint-disable-next-line no-param-reassign
        acc[option.name] = item;
      }
      return acc;
    }, {});
    currentState.model = model;
    currentState.customizable = customizable;
    currentState.encodedCustomizable = encodeCustomizable(model, customizable);
    currentState.price = payload.price;
    currentState.information = payload.information;
  },
  [types.SET_SELECTED_OPTION](state, payload) {
    var currentState = state;
    currentState.selectedOption = payload;
  },
  [types.RESTORE_CUSTOMIZABLE](state) {
    var currentState = state;
    currentState.encodedCustomizable = currentState.oldCustomizable;
  },
  [types.SET_CONFIGURATOR](state, payload) {
    var currentState = state;
    if (payload) {
      currentState.oldCustomizable = currentState.encodedCustomizable;
    }
    currentState.configurator = payload;
  },
  [types.SELECT_OPTION_ITEM](state, payload) {
    var currentState = state;
    currentState.customizable[payload.option.name] = payload.item;
    currentState.encodedCustomizable = encodeCustomizable(currentState.model, currentState.customizable);
  },
  [types.SELECT_OPTION_ITEM_NESTED](state, payload) {
    var currentState = state;
    currentState.customizable[payload.option.name] = payload.item;
    [currentState.customizable.functionality] = payload.item.subItems;
    currentState.encodedCustomizable = encodeCustomizable(currentState.model, currentState.customizable);
  }
};